import { render, staticRenderFns } from "./Telematics-event-detail.vue?vue&type=template&id=bf437ab6&"
import script from "./Telematics-event-detail.vue?vue&type=script&lang=ts&"
export * from "./Telematics-event-detail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports